import { render } from "./DemosDrawer.vue?vue&type=template&id=52a49b95"
import script from "./DemosDrawer.vue?vue&type=script&lang=js"
export * from "./DemosDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__